<template>
  <div class="picture">
    <div class="content"> 
      <div class="name">兆物信链</div>
      <div class="label">国产自主可控区块链技术领军者</div>
      <div class="label">区块链全生态解决方案提供商</div>
      <div class="button">
        <div class="button1" @click="goabout()">商务合作</div>
        <div class="button2" @click="gorecruitment()">加入我们</div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "bigPicture",
        methods: {
            gorecruitment(){
                this.$router.push({
                    name: 'recruitment'
                })
            },
            goabout(){
                this.$router.push({
                    name: 'about'
                })
            },
            getEquipment() {
            let equ = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      }
        }
    }

</script>

<style scoped lang="scss">
    .picture{
        margin-top: 78px;
        width: 100%;
        height: 500px;
        background: url("../../assets/home/bigPicture.png") no-repeat center center;
        background-size: 100% 100%;
        .content{
            max-width: 1280px;
            margin: 0 auto;
            padding-top: 60px;
            /*padding-left: 100px;*/
            .name{
                width: 200px;
                height: 70px;
                font-size: 50px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bolder;
                color: #282B31;
                line-height: 70px;
            }
            .label{
                width: 256px;
                height: 28px;
                font-size: 16px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 300;
                color: #2D3036;
                line-height: 28px;
            }
            .button{
                margin-top: 60px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                display: flex;
                .button1{
                    color: #FFFFFF;
                    line-height: 40px;
                    text-align: center;
                    width: 140px;
                    height: 40px;
                    border-radius: 20px;
                    background-color: #0069FD;
                    margin-right: 23px;
                    cursor: pointer;
                }
                .button2{
                    line-height: 40px;
                    text-align: center;
                    width: 140px;
                    height: 40px;
                    border-radius: 20px;
                    color: #333333;
                    background-color: #DFEAFA;
                    cursor: pointer;
                }
            }
        }
    }
</style>
